module.exports = __webpack_public_path__ + "img/section2_icon2.3c96f050.svg";